<template>
  <section class="co-surface co-bottleneck">
    <h2 class="co-section-title co-bottleneck__title">
      Gargalos identificados
    </h2>
    <div class="co-bottleneck__panel co-bottleneck__panel--wide">
      <h3 class="co-bottleneck__subtitle">
        Resumo operacional
      </h3>
      <ul class="co-bottleneck__bullets">
        <li
          v-for="(item, i) in summaryItems"
          :key="i"
        >
          <feather-icon
            :icon="item.icon"
            size="18"
            class="co-bottleneck__bullet-icon"
          />
          <div>
            <strong>{{ item.title }}</strong>
            <span>{{ item.text }}</span>
          </div>
        </li>
      </ul>
    </div>
  </section>
</template>

<script>
export default {
  name: 'CentralBottlenecksSection',
  props: {
    summaryItems: {
      type: Array,
      default: () => [],
    },
  },
}
</script>

<style scoped>
.co-surface {
  background: #faf8fc;
  border-radius: 24px;
  padding: 1.75rem 1.75rem 1.5rem;
  border: 1px solid rgba(106, 27, 154, 0.08);
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.04);
}

.co-section-title {
  margin: 0 0 1.25rem;
  font-size: 1.35rem;
  font-weight: 800;
  color: #4a148c;
  letter-spacing: -0.02em;
}

.co-bottleneck__panel {
  background: #fff;
  border-radius: 20px;
  padding: 1.35rem 1.35rem 1.25rem;
  border: 1px solid rgba(0, 0, 0, 0.06);
  box-shadow: 0 2px 16px rgba(0, 0, 0, 0.04);
}

.co-bottleneck__panel--wide {
  max-width: 100%;
}

.co-bottleneck__subtitle {
  margin: 0 0 1rem;
  font-size: 0.95rem;
  font-weight: 800;
  color: #4a148c;
  letter-spacing: -0.01em;
}

.co-bottleneck__bullets {
  list-style: none;
  margin: 0;
  padding: 0;
}

.co-bottleneck__bullets li {
  display: flex;
  gap: 0.75rem;
  align-items: flex-start;
  margin-bottom: 1rem;
  font-size: 0.92rem;
  line-height: 1.45;
  color: #424242;
}

.co-bottleneck__bullets li:last-child {
  margin-bottom: 0;
}

.co-bottleneck__bullet-icon {
  flex-shrink: 0;
  color: #7b1fa2;
  margin-top: 2px;
}

.co-bottleneck__bullets strong {
  display: block;
  color: #4a148c;
  font-size: 0.8rem;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  margin-bottom: 0.15rem;
}
</style>
